import { readAuthCookies } from "../../utils/authUtils";
import { APIs } from "../../utils/worker";

// TODO: remove after QA testing — hardcoded edit lookup email
export const RBAC_TEST_EDIT_EMAIL = "akit22@yopmail.com";

export const getRbacRequestHeaders = (extraHeaders = {}) => {
  const token = getRbacAuthToken();

  return {
    accept: "application/json",
    ...(token ? { authorization: `Bearer ${token}` } : {}),
    ...extraHeaders,
  };
};

export const getRbacAuthToken = () => {
  try {
    const userinfo = JSON.parse(localStorage.getItem("userinfo") || "null");
    if (userinfo?.accessToken) {
      return userinfo.accessToken;
    }
  } catch {
    // ignore parse errors
  }

  const cookieAuth = readAuthCookies();
  return cookieAuth?.accessToken || cookieAuth?.id_token || null;
};

export const getRbacApiBaseUrl = () =>
  APIs?.bffBaseURL || APIs?.accessRolesBaseURL || null;

export const getRbacUsersListUrl = () => {
  const baseUrl = APIs?.accessRolesBaseURL || APIs?.bffBaseURL;
  if (!baseUrl) {
    return null;
  }

  return `${baseUrl}/rbac/users`;
};

export const getRbacUsersUrl = () => {
  const baseUrl = APIs?.accessRolesBaseURL || APIs?.bffBaseURL;
  if (!baseUrl) {
    return null;
  }

  return `${baseUrl}/rbac/users`;
};

export const getRbacCognitoStatusUrl = (email) => {
  const baseUrl = APIs?.accessRolesBaseURL || APIs?.bffBaseURL;
  if (!baseUrl || !email) {
    return null;
  }

  const params = new URLSearchParams({ email: String(email).trim() });
  return `${baseUrl}/rbac/users/cognito/status?${params.toString()}`;
};

export const getRbacEmailVerificationUrl = () => {
  const baseUrl = APIs?.accessRolesBaseURL || APIs?.bffBaseURL;
  if (!baseUrl) {
    return null;
  }

  return `${baseUrl}/rbac/auth/email/send-verification-code`;
};

export const getRbacEmailVerifyCodeUrl = () => {
  const baseUrl = APIs?.accessRolesBaseURL || APIs?.bffBaseURL;
  if (!baseUrl) {
    return null;
  }

  return `${baseUrl}/rbac/auth/email/verify-code`;
};

export const getRbacVerifyKeyUrl = (mobileNumber) => {
  const baseUrl = APIs?.accessRolesBaseURL || APIs?.bffBaseURL;
  if (!baseUrl || !mobileNumber) {
    return null;
  }

  const params = new URLSearchParams({
    mobileNumber: String(mobileNumber).trim(),
  });
  return `${baseUrl}/rbac/users/verify-key?${params.toString()}`;
};

export const getHubCpId = () => {
  try {
    const activeHub = JSON.parse(localStorage.getItem("active_hub") || "null");
    if (activeHub?.hubId) {
      return String(activeHub.hubId);
    }
  } catch {
    // ignore parse errors
  }

  try {
    const userData = JSON.parse(localStorage.getItem("userId") || "null");
    if (userData?.userInfo?.premiseId) {
      return String(userData.userInfo.premiseId);
    }
  } catch {
    // ignore parse errors
  }

  return null;
};

export const getRbacLocationByHubCpUrl = (hubCpId) => {
  const baseUrl = APIs?.bffBaseURL || getRbacApiBaseUrl();
  if (!baseUrl || !hubCpId) {
    return null;
  }

  return `${baseUrl}/rbac/locations/hub-cp/${hubCpId}`;
};

export const logRbacFormDataPayload = (label, formData) => {
  if (!(formData instanceof FormData)) {
    console.log(`[RBAC Staff] ${label}`, formData);
    return;
  }

  const payload = {};
  formData.forEach((value, key) => {
    if (value instanceof File) {
      payload[key] = {
        fileName: value.name,
        fileSize: value.size,
        fileType: value.type,
      };
      return;
    }

    try {
      payload[key] = JSON.parse(value);
    } catch {
      payload[key] = value;
    }
  });

  console.log(`[RBAC Staff] ${label}`, payload);
};
